import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.hooks.usePasskeyErrorToast', {
    whatIsPasskey: 'What is a passkey?',
    howToPasskey: 'How to set up / delete a passkey',
});
